var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"artist-name"},[_vm._v(_vm._s(_vm.fullName))]),_vm._v(" "),_c('span',{staticClass:"d-inline-block artist-birthnote pl-0"},[_vm._v(_vm._s(_vm.artistBirthnote))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1788c796","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/shared/components/artist_details.vue
// module id = 51
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 14 15 16 17 18 19 26 29 30 31 32 33 34 36 40 44 51 70 83 84 86 87 88 91 92 95 97 99 101 102 107 108 111 113 114 115 117 120 124 127 135 140 143 144 158 161 164 165 180 215 217 218 224 248 256 265 361